import { render, staticRenderFns } from "./UsersPageNew.vue?vue&type=template&id=104d96ea&scoped=true&"
import script from "./UsersPageNew.vue?vue&type=script&lang=js&"
export * from "./UsersPageNew.vue?vue&type=script&lang=js&"
import style0 from "./UsersPageNew.vue?vue&type=style&index=0&id=104d96ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d96ea",
  null
  
)

export default component.exports